import type React from "react";
import Dropzone from "react-dropzone";
import PlusCircleIcon from "@heroicons/react/24/outline/PlusCircleIcon";

import { IdCardLarge } from "./icons/IdCardLarge";
import { IdCardSmall } from "./icons/IdCardSmall";
import { ClassScheduleLarge } from "./icons/ClassScheduleLarge";
import { ClassScheduleSmall } from "./icons/ClassScheduleSmall";

type AllowedDocumentType = "ID_CARD" | "SCHEDULE";

export const STUDENT_DOC_TYPES: AllowedDocumentType[] = ["ID_CARD", "SCHEDULE"];

interface Props {
  type: AllowedDocumentType;
  onFileDrop: (files: File[], type?: string) => void;
  style?: "large" | "small";
}

function getIcon(type: AllowedDocumentType, size: "small" | "large"): typeof IdCardLarge {
  if (type === "ID_CARD" && size === "large") return IdCardLarge;
  if (type === "ID_CARD" && size === "small") return IdCardSmall;
  if (type === "SCHEDULE" && size === "large") return ClassScheduleLarge;
  if (type === "SCHEDULE" && size === "small") return ClassScheduleSmall;

  return IdCardSmall;
}

export const DocumentTypeUpload: React.FC<Props> = ({ onFileDrop, type, style = "small" }) => {
  const Icon = getIcon(type, style);

  return (
    <Dropzone onDrop={(files) => onFileDrop(files, type)}>
      {({ getRootProps, getInputProps }) => (
        <section {...getRootProps()} className="sid-document-type-attachment-wrap">
          <input {...getInputProps()} />
          {style === "small" ? (
            <button className="sid-document-type-attachment" type="button">
              <Icon className="sid-document-type-attachment__icon-small" />
              <span className="sid-document-type-attachment__text">
                {type === "ID_CARD" && <>Dated School ID card</>}
                {type === "SCHEDULE" && <>Class Schedule</>}
              </span>
              <PlusCircleIcon className="sid-document-type-attachment__plus" />
            </button>
          ) : (
            <button
              className="sid-document-type-attachment sid-document-type-attachment__large"
              type="button"
            >
              <Icon className="sid-document-type-attachment__icon-large" />
              <span className="sid-document-type-attachment__text-large">
                {type === "ID_CARD" && <>Add your dated school ID card</>}
                {type === "SCHEDULE" && <>Add your class schedule</>}
              </span>
            </button>
          )}
        </section>
      )}
    </Dropzone>
  );
};
